import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const TrainingLinks = ({ title }) => {
  return (
    <UserBlock>
      <TabBlock>
        <StyledLink to="/templateVideos">Шаблоны видео тренировок</StyledLink>
        <StyledLink to="/subtemplateVideos">Подшаблоны видео тренировок</StyledLink>
        <StyledLink to="/trainingVideos">Видео тренировок</StyledLink>
      </TabBlock>
      <MainTitle>{title}</MainTitle>
    </UserBlock>
  );
};

export default TrainingLinks;

const UserBlock = styled.div`
  margin: 0 auto;
  width: 70%;
  margin-bottom: 10px;
`;

const TabBlock = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  padding: 0px 5px;
  margin-left: 5px;
  height: 50px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background: #17ade3;
  color: #fff;
  border-radius: 5px;
  border: 1px solid #000542;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Training/TrainingLinks.jsx